import { render, staticRenderFns } from "./configuracoes.vue?vue&type=template&id=30721fc8&"
import script from "./configuracoes.vue?vue&type=script&lang=js&"
export * from "./configuracoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports